import React, { Component } from 'react';
import Swiper from 'swiper';
import VideoCover from 'react-video-cover';
import LazyLoad from 'react-lazyload';

// Assets
import '../../assets/css/swiper.min.css';
import './Jumbotron.scss';
import { parseSanitizedHTML } from '../../utils/Helper';

class Jumbotron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainBannerInit: false,
      mousePause: false,
    };
  }

  componentDidMount() {
    this.setState({
      mainBannerInit: false,
    });
  }

  componentDidUpdate() {
    const _this = this;
    const _thisInitSwiper = this.initSwiper;
    const thumbs = document.querySelectorAll('.main-banner__thumb');
    if (!_this.state.mainBannerInit && thumbs.length > 1) {
      _thisInitSwiper(_this);
      [].forEach.call(thumbs, function (el) {
        el.classList.remove('is-active');
      });

      const tar = thumbs[0];
      if (tar) {
        tar.className += ' is-active';
      }
      _this.setState({
        mainBannerInit: true,
      });
    }

    const mbs = document.getElementById('main-banner-slider');

    if (mbs) {
      if (typeof mbs.swiper !== 'undefined') {
        if (this.state.mousePause) {
          mbs.swiper.autoplay.stop();
        } else {
          mbs.swiper.autoplay.start();
        }
      }
    }
  }

  togglePause = () => {
    this.setState({
      mousePause: !this.state.mousePause,
    });
  };

  updateThumb = (swiper) => {
    const thumbs = document.querySelectorAll('.main-banner__thumb');
    [].forEach.call(thumbs, function (el) {
      el.classList.remove('is-active');
    });

    let activeId = swiper.activeIndex;
    if (activeId > thumbs.length) {
      activeId = 1;
    }
    activeId--;

    // console.log(activeId);
    const tar = thumbs[activeId + 1];
    if (tar) {
      tar.className += ' is-active';
    }

    this.playCurrentVideo();
  };

  toMainBannerSlide = (key) => (e) => {
    const thisElem = document.getElementById('main-banner-slider');
    if (thisElem && thisElem.swiper) {
      thisElem.swiper.slideTo(parseInt(key, 10)); // PHR-581
    }
    e.preventDefault();
  };

  playCurrentVideo = () => {
    /*
     * A refactored method created for playing the video jumbotron, based on the original video playing approach developed by FS
     */
    const vids = document.querySelectorAll('.swiper-slide-active video');
    if (vids.length) {
      vids[0].play();
    }
  };

  initSwiper = (_this) => {
    const thisElem = document.getElementById('main-banner-slider');
    if (thisElem && thisElem.swiper) {
      thisElem.swiper.destroy(false, false);
    }
    const mainBanner = document.getElementById('main-banner-slider');
    const autoplayTime = 6000;
    if (mainBanner) {
      if (mainBanner.swiper) {
        mainBanner.swiper.destroy(true, true);
      }
    }
    const swiper = new Swiper(mainBanner, {
      init: false,
      spaceBetween: 20,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: false,
      effect: 'fade',
      simulateTouch: true,
      autoHeight: true,
      autoplay: {
        delay: autoplayTime,
        disableOnInteraction: false,
      },
      fadeEffect: {
        crossFade: true,
      },
    });
    swiper
      .on('init', function () {
        // swiper.update();
        _this.playCurrentVideo();
      })
      .on('slideChangeTransitionEnd', function () {
        _this.updateThumb(swiper);
        // swiper.autoplay.start();
      })
      .on('slideChangeTransitionStart', function () {
        // reset all video time to zero
        let vids = document.querySelectorAll('.main-banner__slide  video');
        for (let i = 0; i < vids.length; i++) {
          vids[i].currentTime = 0;
        }
      })
      .init();
  };

  render() {
    const _that = this;
    const jumbotronContainer = this.props.banners;

    return (
      <section className="section-mainPage-Jumbotron">
        <div className="main-banner">
          <div id="main-banner-slider" className="main-banner__slider">
            <div
              className={this.state.mousePause ? 'swiper-wrapper pause-active' : 'swiper-wrapper'}
            >
              {/* this.props.cmsData.isLoading ? <div className="main-banner__loading">Loading</div> : '' */}
              {Object.keys(jumbotronContainer || {}).map(function (key) {
                const value = jumbotronContainer[key];

                const title = value.headline || '';
                const subTitle = value.sub_headline_1 || '';
                const subTitle2 = value.sub_headline_2 || '';
                const desc = value.description || '';
                const vid = value.videoPathUrl || '';
                const href = value.landing_url || '';
                const img = value.image || '';
                const imgMobile = value.imageMobile;
                const bg = `url("${img}")`;
                const bgMobile = `url("${imgMobile}")`;
                const imgFocusX = value.image_focus_x || '50';
                const imgFocusY = '50';
                const interval = value.interval || 6000;

                const video = (
                  <video>
                    <source src={vid} type="video/mp4" />
                  </video>
                );

                const videoOptions = {
                  src: vid,
                  // autoplay: "true",
                  // loop: "true",
                  // forceFallback:true,
                  // onFallbackDidMount:function(){
                  //   alert('fullback');
                  // },
                  muted: true,
                  playsInline: true,
                  'webkit-playsinline': 'true',
                };
                return (
                  <div
                    key={`key-${key}`}
                    className="main-banner__slide swiper-slide"
                    data-swiper-autoplay={interval}
                  >
                    {vid === '' ? (
                      <>
                        <a
                          {...(href ? { href } : {})}
                          target="_blank"
                          className="main-banner__img"
                          style={{
                            backgroundImage: bg,
                            backgroundPositionX: `${imgFocusX}%`,
                            backgroundPositionY: `${imgFocusY}%`,
                          }}
                          rel="noopener noreferrer"
                        >
                          <LazyLoad>
                            <img src={img} alt={title} title={title} />
                          </LazyLoad>
                        </a>
                        <a
                          {...(href ? { href } : {})}
                          target="_blank"
                          className="main-banner__img_mobile"
                          style={{
                            backgroundImage: imgMobile ? bgMobile : bg,
                            backgroundPositionX: imgFocusX + '%',
                            backgroundPositionY: imgFocusY + '%',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                          }}
                          rel="noopener noreferrer"
                        ></a>
                      </>
                    ) : (
                      <a
                        {...(href ? { href } : {})}
                        target="_blank"
                        className="main-banner__vid"
                        rel="noopener noreferrer"
                      >
                        <span className="visually-hidden">Label</span>
                        <VideoCover videoOptions={videoOptions} />
                      </a>
                    )}

                    <div className="main-banner__txt">
                      {title !== '' && (
                        <a {...(href ? { href } : {})} target="_blank" rel="noopener noreferrer">
                          <h2 className="main-banner__title">{title}</h2>
                        </a>
                      )}
                      {(subTitle !== '' || subTitle2 !== '' || desc !== '') && (
                        <div className="main-banner__detail">
                          <a {...(href ? { href } : {})} target="_blank" rel="noopener noreferrer">
                            <h3 className="main-banner__detail-title">{subTitle}</h3>
                            <h3 className="main-banner__detail-subHeading">{subTitle2}</h3>
                          </a>
                          <p className="main-banner__detail-desc">{parseSanitizedHTML(desc)}</p>
                          {/* <BtnShareContainer  pageUrl={href}  pageShareTitle={title} devType={title}/> */}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              tabIndex="0"
              className={
                this.state.mousePause
                  ? 'main-banner__slider-pause is-active'
                  : 'main-banner__slider-pause'
              }
              onClick={this.togglePause}
              onKeyPress={this.togglePause}
            >
              {/* <label htmlFor="playpause"></label> */}
              <div className="pause-button">
                <span className="visually-hidden">Pause</span>
              </div>
            </div>
          </div>
          <div className="main-banner__thumbs">
            <div className="content-wrapper">
              {Object.keys(jumbotronContainer || {}).map(function (key) {
                const value = jumbotronContainer[key];
                const img = value.image;
                const bg = `url("${img}")`;
                return (
                  <span
                    tabIndex="0"
                    key={`key-${key}`}
                    onClick={_that.toMainBannerSlide(key)}
                    onKeyPress={_that.toMainBannerSlide(key)}
                    className="main-banner__thumb"
                    style={{ backgroundImage: bg }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Jumbotron;
